<template>
  <div :class="[{'hidden':hidden},{'shoHome':prevText}]" class="pagination-container">
    <el-pagination
        :background="background"
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :layout="layout"
        :page-sizes="pageSizes"
        :total="totalCount"
        v-bind="$attrs"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :prev-text="prevText"
        :next-text="nextText"
    >
      <el-button v-if="prevText" @click.native="goHome" class="home-back"><span>首页</span></el-button>
    </el-pagination>
  </div>
</template>

<script>
import {scrollTo} from '@/utils/scroll-to'

export default {
  name: 'pagination',
  props: {
    isTop: {
      type: Boolean,
      default: true
    },
    /*count: {
        required: true,
        type: Number
    },*/
    totalCount: {
      type: Number,
      default: 0
    },
    page: {
      type: Number,
      default: 1
    },
    limit: {
      type: Number,
      default: 20
    },
    pageSizes: {
      type: Array,
      default() {
        return [10, 20, 30, 50]
      }
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next, jumper'
    },
    background: {
      type: Boolean,
      default: true
    },
    autoScroll: {
      type: Boolean,
      default: false
    },
    hidden: {
      type: Boolean,
      default: false
    },
    prevText: {
      type: String,
      default: ''
    },
    nextText: {
      type: String,
      default: ''
    },
  },
  computed: {
    currentPage: {
      get() {
        return this.page
      },
      set(val) {
        this.$emit('update:page', val)
      }
    },
    pageSize: {
      get() {
        return this.limit
      },
      set(val) {
        this.$emit('update:limit', val)
      }
    }
  },
  methods: {
    goHome(e) {
      this.$emit('goHome', {page: 1, limit: this.pageSize})
      if (!this.isTop) return;
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    },
    handleSizeChange(val) {
      this.$emit('pagination', {page: this.currentPage, limit: val})
      if (!this.isTop) return;
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    },
    handleCurrentChange(val) {
      this.$emit('pagination', {page: val, limit: this.pageSize})
      if (!this.isTop) return;
      if (this.autoScroll) {
        scrollTo(0, 800)
      }
    }
  }
}
</script>

<style lang="less">
.shoHome {
  .btn-prev {
    display: none !important;
  }
}
</style>

<style scoped>

.home-back {
  background: #f4f4f5;
}

.pagination-container {
  background: #fff;
  padding: 10px 16px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}

.pagination-container.hidden {
  display: none;
}
</style>
